//郑州专题
const routerConfig = {
  baseUrl: '/2022/cloudshow/',
  router: [{
    path: '/main',
    name: 'Main',
    component: resolve => require(['@/pages/cloudshow/Index'], resolve),
    meta: {
      title: '云车展'
    },
    children: [
      {
        path: 'index',
        name: "Index",
        component: resolve => require(['@/pages/cloudshow/homePage'], resolve),
        meta: {
          title: '云车展'
        },
      },
      {
        path: 'role',
        name: "Role",
        component: resolve => require(['@/pages/cloudshow/Role'], resolve),
        meta: {
          title: '活动规则'
        },
      },
      {
        path: 'carlist',
        name: "CarList",
        component: resolve => require(['@/pages/cloudshow/CarList'], resolve),
        meta: {
          title: '二手车春季云车展'
        },
      }
    ]
  }
  ]
}
export default routerConfig;


// WEBPACK FOOTER //
// ./src/router/routerConfig.js